<template>
  <div class="store-mapping-form">
    <NavHeaderBar :showSearch="false" :navBarTitle="pageTitle" />
    <div class="create-store-form" v-if="!successStatus">
      <div class="form-item uploader-customer" v-if="sdId">
        <div class="label required">
          <span>{{ $t('form.checkInPhoto') }}</span>
        </div>
        <van-uploader v-model="sd.checkInImgUrl" max-count="1" :after-read="(files, detail) => afterRead(files, detail, 'checkInImgUrl')" />
      </div>
      <van-collapse v-model="activeNames">
        <van-collapse-item title="Basic info." name="1">
          <div class="form-item">
            <div class="label required">
              <span>{{ $t('form.distributorName') }}</span>
            </div>
            <van-field v-model="sd.sdName" placeholder="" :border="false" class="custom-field" />
          </div>
          <div class="form-item">
            <div class="label required">
              <span>{{ $t('form.outsidePicture') }}</span>
            </div>
            <van-uploader v-model="sd.imgUrl" max-count="1" :after-read="(files, detail) => afterRead(files, detail, 'imgUrl')" />
          </div>
          <div class="form-item">
            <div class="label required">
              <span>{{ $t('form.address') }}</span>
            </div>
            <van-field readonly v-model="sd.address" placeholder="" :border="false" class="custom-field" @click="getAddress" />
          </div>
          <div class="form-item">
            <div class="label required">
              <span>{{ $t('form.distributorTag') }}</span>
            </div>
            <XuSelect v-model="sd.sdTag" :dataOptions="sdTagList" />
          </div>
          <div class="form-item">
            <div class="label required">
              <span>{{ $t('form.distributorType') }}</span>
            </div>
            <XuSelect v-model="sd.sdType" :multiple="true" :dataOptions="sdTypeList" />
          </div>
          <div class="form-item">
            <div class="label required">
              <span>{{ $t('form.businessType') }}</span>
            </div>
            <XuSelect v-model="sd.businessType" :dataOptions="globalData.sdBusinessType" />
          </div>
        </van-collapse-item>
        <van-collapse-item title="Decision-maker Info." name="2">
          <div class="form-item">
            <div class="label">
              <span>{{ $t('form.decisionMakerName') }}</span>
            </div>
            <van-field v-model="decisionContact.contactName" placeholder="" :border="false" class="custom-field" />
          </div>
          <div class="form-item">
            <div class="label">
              <span>{{ $t('form.decisionMakerRole') }}</span>
            </div>
            <XuSelect v-model="decisionContact.job" :dataOptions="jobList" />
          </div>
          <div class="form-item">
            <div class="label">
              <span>{{ $t('form.phone') }}</span>
            </div>
            <van-field v-model="decisionContact.phone" type="number" placeholder="" :border="false" class="custom-field" />
          </div>
          <div class="form-item">
            <div class="label">
              <span>{{ $t('form.email') }}</span>
            </div>
            <van-field v-model="decisionContact.email" placeholder="" :border="false" class="custom-field" />
          </div>
          <div class="form-item">
            <div class="label">
              <span>{{ $t('form.notes') }}</span>
            </div>
            <van-field v-model="decisionContact.remark" placeholder="" :border="false" class="custom-field" />
          </div>
        </van-collapse-item>
        <van-collapse-item title="Foot Traffic Information" name="3">
          <div class="form-item">
            <div class="label">
              <span>{{ $t('form.weekdayFootTraffic') }}</span>
            </div>
            <van-field v-model="sd.weekdayTraffic" placeholder="" type="number" :border="false" class="custom-field" />
          </div>
          <div class="form-item">
            <div class="label">
              <span>{{ $t('form.weekdayPeakTraffic') }} {{ $t('form.timePeriods') }}</span>
            </div>
            <XuTime v-model="sd.weekdayPeakTrafficTime" />
          </div>
          <div class="form-item">
            <div class="label">
              <span>{{ $t('form.weekendFootTraffic') }}</span>
            </div>
            <van-field v-model="sd.weekendTraffic" placeholder="" type="number" :border="false" class="custom-field" />
          </div>
          <div class="form-item">
            <div class="label">
              <span>{{ $t('form.weekendPeakTraffic') }} {{ $t('form.timePeriods') }}</span>
            </div>
            <XuTime v-model="sd.weekendPeakTrafficTime" />
          </div>
        </van-collapse-item>
        <van-collapse-item title="Distributor Customer Reach" name="4">
          <div class="form-item">
            <div class="label custom-label">
              <span>{{ $t('form.numberOfAffiliatedCoreStore') }}</span>
            </div>
            <van-field v-model="sd.coreStoreCount" maxlength="100" placeholder="" :border="false" class="custom-field" />
          </div>
          <div class="form-item">
            <div class="label custom-label">
              <span>{{ $t('form.corePromotedProductBrand') }}</span>
            </div>
            <van-field v-model="sd.coreBrand" placeholder="" :border="false" class="custom-field" />
          </div>
        </van-collapse-item>
        <van-collapse-item title="Distributor Promotion Capability" name="5">
          <div class="form-item">
            <div class="label">
              <span>{{ $t('form.officialWebsiteAvailable') }}</span>
            </div>
            <van-field class="custom-field custom-radio-field">
              <template #input>
                <van-radio-group v-model="sd.isOnlineWeb" direction="horizontal">
                  <van-radio v-for="(subItem, subIndex) in radioList" :key="subIndex" :name="subItem.value">{{ subItem.label }}</van-radio>
                </van-radio-group>
              </template>
            </van-field>
          </div>
          <div class="form-item">
            <div class="label">
              <span>{{ $t('form.whatsAppGroupAvailable') }}</span>
            </div>
            <van-field class="custom-field custom-radio-field">
              <template #input>
                <van-radio-group v-model="sd.isWhatsappGroup" direction="horizontal">
                  <van-radio v-for="(subItem, subIndex) in radioList" :key="subIndex" :name="subItem.value">{{ subItem.label }}</van-radio>
                </van-radio-group>
              </template>
            </van-field>
          </div>
          <div class="form-item">
            <div class="label">
              <span>{{ $t('form.facebookInstagramAvailable') }}</span>
            </div>
            <van-field class="custom-field custom-radio-field">
              <template #input>
                <van-radio-group v-model="sd.isIns" direction="horizontal">
                  <van-radio v-for="(subItem, subIndex) in radioList" :key="subIndex" :name="subItem.value">{{ subItem.label }}</van-radio>
                </van-radio-group>
              </template>
            </van-field>
          </div>
        </van-collapse-item>
      </van-collapse>
    </div>
    <div class="success-submit-status" v-else>
      <img class="success-img" src="@/assets/images/gouxuan.png" alt="">
      <!-- 当前Distributor mapping成功，接下来可通过visit收集更多信息 -->
      <span class="success-tip">{{ $t('tips.messageThirtyTwo') }}.</span>
      <div class="store-detail-btn" @click="toPage(`/salesDistribution/sdMappingDetail`)">{{ $t('button.distributorDetial') }}</div>
      <div class="visit-sell-in-btn" v-if="![-1, -2, -3, '-1', '-2', '-3'].includes(sd.status)" @click="toPage(`/salesDistribution/sdVisit?customerId=${sdId}`, 'visit')">{{ $t('shared.visitSellIn') }}</div>
    </div>
    <div class="oper-btn" v-if="!successStatus">
      <van-button class="mapping-btn" type="info" @click="handleSubmit">{{ $t('button.submit') }}</van-button>
    </div>
    <XuVisitDialog ref="xuVisitDialogRef" :currentVisitInfo="currentVisitInfo" :customerId="sdId" pageType="salesDistribution" />
  </div>
</template>

<script>
import { Toast } from 'vant'
import { sdAddApi, sdUpdateApi, updateInfoApi } from '@/api/salesDistribution'
import XuTime from '@/components/XuTime.vue'
import { arsVisitLastApi } from '@/api/visit'
import { mapState } from 'vuex'
export default {
  name: 'StoreMapping',
  components: {
    XuSelect: () => import('@/components/XuSelect'),
    XuTime,
    XuVisitDialog: () => import('@/components/XuVisitDialog')
  },
  data () {
    return {
      successStatus: false,
      sdId: '',
      pageType: 'salesDistribution',
      activeNames: ['1'],
      sd: {
        lng: '',
        lat: '',
        sdName: '',
        address: '',
        sdTag: '',
        sdType: [],
        businessType: '',
        imgUrl: [],
        checkInImgUrl: [],
        weekdayTraffic: '',
        weekdayPeakTrafficTime: [{ start: '', end: '' }],
        weekendTraffic: '',
        weekendPeakTrafficTime: [{ start: '', end: '' }],
        coreStoreCount: '',
        coreBrand: '',
        isOnlineWeb: '',
        isWhatsappGroup: '',
        isIns: ''
      },
      decisionContact: {
        contactName: '',
        job: '',
        phone: '',
        email: '',
        remark: ''
      },
      jobList: [],
      radioList: [
        { label: this.$t('shared.filter.yes'), value: true },
        { label: this.$t('shared.filter.no'), value: false }
      ],
      currentVisitInfo: {},
      pageTitle: this.$t('shared.title.distributorMapping'),
      sdTagList: [
        { label: this.$t('form.keyDistributor'), value: 1 },
        { label: this.$t('form.notKeyDistributor'), value: 0 }
      ],
      sdTypeList: [
        { label: this.$t('shared.filter.mD'), value: 'MD' },
        { label: this.$t('shared.filter.kA'), value: 'KA' },
        { label: this.$t('shared.filter.sDSmokeDistro'), value: 'SD(Smoke Distro)' },
        { label: this.$t('shared.filter.sDMultiItemDistro'), value: 'SD(Multi-item Distro)' }
      ]
    }
  },
  computed: {
    ...mapState({
      globalData: 'globalData',
      userInfo: 'myUserInfo'
    })
  },
  activated () {
    this.pageType = this.$route.query.pageType || 'salesDistribution'
    this.pageTitle = this.$t('shared.title.distributorMapping')
    this.activeNames = ['1']
    this.successStatus = false
    this.sdId = this.$route.query.customerId || ''
    this.$nextTick(() => {
      this.initData()
    })
  },
  methods: {
    handleSubmit () {
      if (!this.checkedForm()) return
      this.dataSubmit()
    },
    dataSubmit () {
      const { imgUrl, weekdayPeakTrafficTime, weekendPeakTrafficTime, checkInImgUrl, sdType } = this.sd
      const data = {
        sd: {
          ...this.sd,
          imgUrl: imgUrl.map(imgItem => imgItem.url).join(','),
          checkInImgUrl: checkInImgUrl.map(imgItem => imgItem.url).join(','),
          weekdayPeakTrafficTime: weekdayPeakTrafficTime.length <= 0 ? '' : weekdayPeakTrafficTime.map(timeItem => `${timeItem.start}~${timeItem.end}`).join(','),
          weekendPeakTrafficTime: weekendPeakTrafficTime.length <= 0 ? '' : weekendPeakTrafficTime.map(timeItem => `${timeItem.start}~${timeItem.end}`).join(','),
          id: this.sdId,
          sdType: sdType.join(',')
        },
        decisionContact: this.decisionContact
      }
      const requestApi = this.sdId ? sdUpdateApi : sdAddApi
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      requestApi(data).then(res => {
        Toast.clear()
        this.sdId = res.data.id
        this.successStatus = true
        this.pageTitle = this.$t('shared.title.mappingSucceed')
        localStorage.removeItem('centerPoint')
      })
    },
    toPage (url, type) {
      if (type === 'visit') {
        if (!this.sdId) {
          return
        }
        Toast.loading({
          message: this.$t('shared.loading'),
          forbidClick: true,
          duration: 0
        })
        arsVisitLastApi(this.sdId, '1').then(res => {
          Toast.clear()
          this.currentVisitInfo = res.data
          if (res.data.lastType === 0) {
            this.$router.replace(url)
          } else {
            this.$refs.xuVisitDialogRef.dialogShow = true
          }
        })
      } else if (url === '/salesDistribution/sdMappingDetail') {
        this.$router.replace(`${url}?customerId=${this.sdId}&pageType=${this.pageType}`)
      } else {
        this.$router.replace(url)
      }
    },
    getUpdateInfo () {
      if (JSON.parse(localStorage.getItem('centerPoint'))) return
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      updateInfoApi(this.sdId).then(res => {
        Toast.clear()
        const { sd, decisionContact } = res.data
        Object.keys(this.decisionContact).forEach(subItem => {
          this.decisionContact[subItem] = decisionContact[subItem] || ''
        })
        Object.keys(this.sd).forEach(subItem => {
          if (subItem === 'imgUrl') {
            this.sd[subItem] = sd[subItem] ? sd[subItem].split(',').map(imgItem => {
              return { url: imgItem }
            }) : []
          } else if (subItem === 'checkInImgUrl') {
            this.sd[subItem] = []
          } else if (subItem === 'sdType') {
            this.sd[subItem] = sd[subItem] !== '' ? sd[subItem].split(',') : []
          } else if (['weekdayPeakTrafficTime', 'weekendPeakTrafficTime'].includes(subItem)) {
            // '9:30~3:30,9:30~3:30' [9:30~3:30, 9:30~3:30]
            if (sd[subItem]) {
              const newTime = []
              const startEndTimeList = sd[subItem].split(',')
              startEndTimeList.forEach(timeItem => {
                newTime.push({ start: timeItem.split('~')[0], end: timeItem.split('~')[1] })
              })
              this.sd[subItem] = newTime
            } else {
              this.sd[subItem] = [{ start: '', end: '' }]
            }
          } else {
            // this.sd[subItem] = sd[subItem] || ''
            this.$set(this.sd, subItem, ['', null].includes(sd[subItem]) ? '' : sd[subItem])
          }
        })
      })
    },
    afterRead (files, detail, key) {
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      this.$uploadImg(files)
        .then((res) => {
          Toast.clear()
          this.$set(this.sd[key], detail.index, {
            url: res.url
          })
        })
        .catch((err) => {
          console.log('err', err)
          Toast.clear()
          Toast(this.$t('tips.uploadFailed'))
        })
    },
    getAddress () {
      const query = {
        longitude: this.sd.lng || '',
        latitude: this.sd.lat || ''
      }
      this.$router.push({
        path: '/chooseLocation',
        query: query
      })
    },
    // 校验必填
    checkedForm () {
      const field = [
        { tipsText: this.$t('form.storeName'), value: 'sdName' },
        { tipsText: this.$t('form.address'), value: 'address' },
        { tipsText: this.$t('form.outsidePicture'), value: 'imgUrl' },
        { tipsText: this.$t('form.distributorTag'), value: 'sdTag' },
        { tipsText: this.$t('form.distributorType'), value: 'sdType' },
        { tipsText: this.$t('form.businessType'), value: 'businessType' }
      ]
      let isFlag = true
      if (this.sdId && this.sd.checkInImgUrl.length <= 0) {
        Toast(`${this.$t('form.checkInPhoto')} ${this.$t('tips.isRequired')}`)
        isFlag = false
        return isFlag
      }
      field.find(subItem => {
        if (this.isEmptyVal(this.getFieldVal(subItem.value))) {
          isFlag = false
          Toast(`${subItem.tipsText} ${this.$t('tips.isRequired')}`)
          return true // find 只需返回 true 终止遍历，比 return subItem 语义清晰
        }
      })
      return isFlag
    },
    // 空字符串 / 空数组 视为空
    isEmptyVal (val) {
      return val === '' || (Array.isArray(val) && val.length === 0)
    },
    getFieldVal (key) {
      // if (key === 'id') return this.sd.belongSd.id
      return this.sd[key]
    },
    initData () {
      const centerPoint = JSON.parse(localStorage.getItem('centerPoint'))
      if (centerPoint) {
        this.sd.address = centerPoint.address
        this.sd.lng = centerPoint.lng
        this.sd.lat = centerPoint.lat
      }
      this.jobList = []
      this.globalData.customerJob.forEach(subItem => {
        this.jobList.push({ label: subItem.label, value: JSON.parse(subItem.value).val })
      })
      this.getUpdateInfo()
    }
  }
}
</script>

<style scoped lang="less">
.store-mapping-form {
  height: 100%;
  background-color: #f5f5f9;
  display: flex;
  flex-direction: column;
  overflow: auto;
  .success-submit-status {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 100px;
    .success-img {
      width: 80px;
      height: 80px;
    }
    .success-tip {
      width: 260px;
      text-align: center;
      margin: 16px 0 40px 0;
      font-size: 13px;
    }
    .store-detail-btn,
    .visit-sell-in-btn {
      width: 260px;
      padding: 16px 0px;
      border: 1px solid #555;
      color: #555;
      text-align: center;
      font-weight: bold;
      font-size: 17px;
      border-radius: 30px;
      margin-bottom: 16px;
    }
    .visit-sell-in-btn {
      border-color: #307bff;
      color: #307bff;
    }
  }
  .oper-btn {
    width: 100%;
    .mapping-btn {
      width: 100%;
      background-color: #307bff;
      font-weight: bold;
    }
  }
  .create-store-form {
    flex: 1;
    overflow-y: auto;
    padding: 5px 0;
    .uploader-customer {
      display: flex;
      justify-content: space-between;
      background-color: #fff;
      padding-top: 10px !important;
      margin-bottom: 0 !important;
      .label {
        align-self: flex-start;
      }
    }
    /deep/.van-collapse {
      .van-collapse-item {
        background-color: #fff;
        .van-collapse-item__title {
          background-color: #e8effc;
          font-weight: bold;
          padding: 5px 10px;
          margin-bottom: 2px;
          .van-cell__title {
            font-weight: bold;
            > span {
              font-size: 14px;
            }
          }
        }
        .van-collapse-item__content {
          padding: 0;
          padding-top: 10px;
        }
      }
    }
    .form-item {
      padding: 0 10px;
      margin-bottom: 13px;
      .label {
        display: flex;
        align-items: center;
        font-size: 12px;
        color: #333;
        margin-bottom: 8px;
        // 添加必填标记样式
        &.required {
          position: relative;
          padding-left: 12px; // 为星号预留空间
          &::before {
            content: '*';
            color: #ff4444;
            position: absolute;
            left: 0;
            top: 0;
            font-size: 14px;
            line-height: 1;
          }
        }
        .label-icon {
          width: 16px;
          height: 16px;
          margin-left: 3px;
        }
      }
      .custom-field {
        padding: 5px 10px;
        background: #fff;
        border: 1px solid #b9cbed;
        border-radius: 4px;
        font-size: 12px;
        &::placeholder {
          color: #999;
        }
      }
      .custom-radio-field {
        padding: 0;
        font-size: 12px;
        border: none;
      }
      .phone-inputs {
        display: flex;
        align-items: center;
        .custom-field {
          flex: 1;
          text-align: center;
        }
        span {
          margin: 0 5px;
        }
      }
    }
    .custom-label {
      display: flex;
      align-items: center;
      .label-icon {
        width: 16px;
        height: 16px;
        margin-left: 3px;
      }
    }
  }
}
</style>
